export enum ActivityAuthorType {
  User = 'User',
  System = 'System',
  Undefined = 'Undefined',
}
